<template>
  <div>
    <div class="contact-person-mobile">
      <p class="lib__form__legend contact-person-mobile header">{{ $t('contact.optionalPerson') }}</p>
      <p class="lib__text-gray-600 contact-person-mobile text-info">{{ $t('contact.addPersonDetails') }}</p>
      <div id="contactsContainer">
        <ContactPersonForm :show-send-offer-copy="showSendOfferCopy" :key="'contact-person-' + index" :value="contact"
                             @remove="remove(index)" v-for="(contact, index) in value" />
      </div>
      <div class="contact-person-mobile button-container" v-if="canAdd">
        <button @click.prevent="add" class="lib__btn lib__btn--secondary lib__btn--rounded contact-person-mobile button"
                type="button">
          <i class="fas fa-plus"></i>
          <span>{{ $t('contact.addPerson') }}</span>
        </button>
      </div>
    </div>

    <div class="contact-person-desktop">
      <ContactPersonForm :show-send-offer-copy="showSendOfferCopy" :key="'contact-person-' + index" :value="contact"
                           @remove="remove(index)" v-for="(contact, index) in value" :showCivility="showCivility" />
      <button @click.prevent="add" class="lib__btn-action" type="button" v-if="canAdd">
        <span class="lib__badge lib__badge--primary">
          <i class="fas fa-plus"></i>
        </span>
        <span>
          <span class="lib__btn-action__label">{{ $t('contact.addPerson') }}</span>
          <small v-html="$t('contact.addPersonDetails')"></small>
        </span>
      </button>
    </div>
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator'
import ContactPersonForm from '@/components/inputs/Contact/ContactPersonForm.vue'
import { ContactPerson } from '@/models'
import { contactService } from '@/services'

@Component({
  name: 'contact-people-form',
  components: {
    ContactPersonForm
  }
})
export default class ContactPeopleForm extends Vue {
  //#region [Property]
  @Prop({ type: Array, required: true }) public readonly value!: ContactPerson[]
  @Prop({ type: Boolean, required: false, default: true }) public readonly showSendOfferCopy!: boolean
  @Prop({ required: false, default: null }) public readonly maxContactCount!: number | null
  @Prop({ type: Boolean, required: false, default: false }) public readonly showCivility!: boolean
  //#endregion

  //#region [Method]

  public updated() {
    const otherContactElements =
      document.getElementById('contactsContainer')
        ?.getElementsByClassName('lib__panel') ?? []
    if (otherContactElements.length) {
      otherContactElements[otherContactElements.length - 1].scrollIntoView()
    }
  }

  public add() {
    if (this.canAdd) {
      this.value.push(contactService.createContactPerson())
    }
  }

  public remove(index: number) {
    const contact = this.value[index]
    let name: string = [contact.firstname, contact.lastname].filter((n) => !!n).join(' ')

    if (!!name) {
      name = ` (${name})`
    }

    this.$confirm(this.$t('dialogs.deleteContact', [name]) as string).then((v) => {
      if (v) {
        this.value.splice(index, 1)
      }
    })
  }

  //#endregion

  get canAdd(): boolean {
    return this.maxContactCount === null || this.value.length < this.maxContactCount
  }
}
</script>

<style scoped>
@media screen and (max-width: 576px) {
    .lib__btn.contact-person-mobile.button {
        text-transform: none;
        width: 320px;
    }

    div.contact-person-mobile.button-container {
        width: 320px;
        margin: 20px auto;
    }

    div.contact-person-mobile {
        display: block;
        width: 100%
    }

    div.contact-person-desktop {
        display: none;
    }

    p.contact-person-mobile.header {
        margin-bottom: 20px;
    }

    p.lib__text-gray-600.contact-person-mobile.text-info {
        font-size: 12px;

    }
}

@media screen and (min-width: 577px) {
    div.contact-person-desktop {
        display: initial;
    }

    div.contact-person-mobile {
        display: none;
    }
}
</style>
